<template>
  <template v-if="pageListChild == 'maintainstatus'">
    <!-- 維修狀態 -->
    <maintainStatus></maintainStatus>
  </template>
  <template v-else-if="pageListChild == 'maintainhistoryquery'">
    <!-- 維修履歷查詢 -->
    <maintainHistoryQuery></maintainHistoryQuery>
  </template>
</template>

<script>
import maintainStatus from "@/components/deviceManagement/maintainHistory/maintainStatus.vue";
import maintainHistoryQuery from "@/components/deviceManagement/maintainHistory/maintainHistoryQuery.vue";
import { inject } from "vue";
export default {
  components: {
    maintainStatus,
    maintainHistoryQuery,
  },
  setup() {
    const pageListChild = inject("pageListChild");

    return {
      pageListChild,
    };
  },
};
</script>

<style></style>
